import { Injectable } from "@angular/core";
import {
  CarrotSSOConfiguration,
  PublicConfigService,
} from "../shared/services/public.config.service";
import { DataService } from "../shared/services/data.service";
import Typesense, { Client } from "typesense";

export interface SearchForumsCriteria {
  searchTerm?: string,
  category?: string,
  isHidden?: boolean,
  createdBy?: string,
  isPinned?: boolean,
  popular?: boolean,
  sortExpresssion?: string, // "createdAt.asc", "createdAt.desc", etc...
  pagination: {
    pageSize: number,
    lastItem?: any,
    currentPage?: number
  }
}

@Injectable({
  providedIn: "root",
})
export class ForumsService {
  private ssoConfiguration: CarrotSSOConfiguration;
  private forumsConfig = null;
  _typesenseClient: Client;

  constructor(
    publicConfigService: PublicConfigService,
    private dataService: DataService
  ) {
    this.ssoConfiguration = publicConfigService.getCarrotSSOConfig();
  }

  async getForumsConfig() {
    if (!this.forumsConfig) {
      this.forumsConfig = await this.dataService
        .get(
          this.ssoConfiguration.ssoBaseUrl +
            `/api/v1/config/client/${this.ssoConfiguration.ssoClientId}/forum`
        )
        .toPromise();
    }
    return this.forumsConfig;
  }

  async searchForumPosts(criteria: SearchForumsCriteria) {
    const config = await this.getForumsConfig();
    let search = {
      q: criteria.searchTerm,
      query_by: "title,descriptionPlain",
      sort_by: criteria.sortExpresssion,
      per_page: criteria.pagination.pageSize,
      page: criteria.pagination.currentPage + 1,
    };
    const filter_by = this.composeFilterByClause(criteria);
    if (filter_by) {
      search["filter_by"] = filter_by;
    }
    const typesenseClient = await this.getTypesenseClient();
    let searchResults = await typesenseClient
      .collections(config.data.typesense.collectionName)
      .documents()
      .search(search);

    return searchResults;
  }

  async getTypesenseClient(): Promise<Client> {
    if (!this._typesenseClient) {
      const config = await this.getForumsConfig();
      this._typesenseClient = new Typesense.Client({
        nodes: [
          {
            host: config.data.typesense.host,
            port: 443,
            protocol: "https",
          },
        ],
        apiKey: config.data.typesense.apiKey,
        connectionTimeoutSeconds: 60,
      });
    }
    return this._typesenseClient;
  }

  public composeFilterByClause(criteria: SearchForumsCriteria): string {
    let filterBy = "";

    if (criteria.createdBy !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "createdBy:=" + criteria.createdBy
      );
    }

    if (criteria.isHidden !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "isHidden:=" + criteria.isHidden
      );
    }

    if (criteria.isPinned !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "isPinned:=" + criteria.isPinned
      );
    }

    if (criteria.category !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "category:=" + criteria.category
      );
    }

    if (criteria.category !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "category:=" + criteria.category
      );
    }

    if (criteria.popular !== undefined) {
      filterBy = this.appendFilterByCondition(
        filterBy,
        "seenCount:>0"
      );
    }

    return filterBy;
  }

  public appendFilterByCondition(filterBy: string, condition: string): string {
    if (filterBy !== "") {
      filterBy += " && ";
    }
    filterBy += condition;
    return filterBy;
  }
}
